const $doc = $(document);

$doc.on('click', '.js-quantity a', function(event) {
  event.preventDefault();

  const $this = $(this);
  const $container = $('.js-quantity');
  const $target = $this.siblings('input');
  const itemKey = $target.data('key');
  const updateOnChange = $target.hasClass('js-quantity-update-on-change');
  const isCartPage = $this.closest('.js-cart-item').length;

  if (!$target.length) {
    return;
  }

  let currentVal = parseInt($target.val());
  const min = parseInt($target.attr('min') || 0);
  const max = parseInt($target.attr('max') || 9999);

  if ($this.hasClass('js-quantity-decrease')) {
    currentVal = currentVal <= min ? min : currentVal - 1;
  }

  if ($this.hasClass('js-quantity-increase')) {
    currentVal = currentVal >= max ? max : currentVal + 1;
  }

  if ($('body').hasClass('template-product')) {
    $container.each(function() {
      const $this = $(this);

      $this.find('input').val(currentVal);
    });
  }

  $('.js-ajax-add').removeClass('form__btn--added');

  // Change line item quantities
  if (updateOnChange) {
    Cart.updateItem(currentVal, itemKey, {}, isCartPage);
  }
});
